import { unavailableCalculationText } from './financial-calculation-roadmap';

/** Version textuelle utilisable aussi dans les titres SVG et noms accessibles. */
export const financialMoney = (cents: string | null | undefined): string =>
  cents == null
    ? unavailableCalculationText('sources')
    : new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(BigInt(cents)) / 100);
